import { connect } from 'react-redux';
import AssetMappingInfo from './assetMappingInfo';
import { bindActionCreators } from 'redux';
import {
  getAssetsInfoData
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    assetsInfo: state.siteListingReducer.assetsInfoData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssetsInfoData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AssetMappingInfo);
